import { message } from 'antd';
import Api from '../services/Api';
import { useTranslation } from 'react-i18next';

export default function useDefaultUploaderProps() {
  const { t } = useTranslation();

  return {
    beforeUpload: (file, fileList) => {
      // 8mb file size limit
      const maxFileSize = 8 * 1024 * 1024;
      if (file.size > maxFileSize) {
        message.error(`${file.name} ${t('file upload failed (exceeds 8MB)')}`);
        console.error('File size exceeds the limit of 8MB');

        return false;
      }

      let allowedTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'image/svg+xml',
        'image/webp',
        'image/avif'
      ];

      if (!allowedTypes.includes(file.type)) {
        message.error(
          file.name +
            ' ' +
            t(
              ` file upload failed (wrong file type). Allowed types: jpg, jpeg, png, gif, avif, svg, webp`
            )
        );
        console.error('File type is not allowed');

        return false;
      }

      return true;
    },
    customRequest: (options) => {
      const { onSuccess, onError, file } = options;

      const formData = new FormData();
      formData.append('file', file);
      Api.uploadFile(formData)
        .then((result) => {
          (file as any).__data__ = result;
          onSuccess(file);
        })
        .catch((error) => {
          console.error(error);
          onError(error);
        });
    },
    data: (file) => {
      return {
        name: file.name
      };
    }
  };
}
